import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { SubtopicItemProps } from '../types';
import KeywordsList from './KeywordsList';

const SubtopicItem: React.FC<SubtopicItemProps> = ({ subtopic }) => {
  const theme = useTheme();
  
  return (
    <Box 
      sx={{ 
        pl: 2,
        borderLeft: `4px solid ${theme.palette.primary.light}`,
        py: 1
      }}
    >
      <Typography 
        variant="subtitle1" 
        sx={{ fontWeight: 'medium', mb: 1.5, color: theme.palette.text.primary }}
      >
        {subtopic.name}
      </Typography>
      
      {/* Keywords */}
      <KeywordsList keywords={subtopic.keywords || []} />
    </Box>
  );
};

export default SubtopicItem;
